import { Button } from "antd";

const arrowStyle = (oldStyle) => {
  return {
    ...oldStyle,
    background: "rgba(168, 168, 168, 0.6)",
    borderRadius: "50%",
    width: "35px",
    height: "35px",
    zIndex: "5",
    color: "white",
  };
};

const NextArrow = ({ style, className, onClick }) => {
  return (
    <Button
      shape="circle"
      onClick={onClick}
      className={className}
      style={arrowStyle(style)}
      icon={<i className="fas fa-chevron-right arrow-slick" />}
    />
  );
};

const PrevArrow = ({ style, className, onClick }) => {
  return (
    <Button
      shape="circle"
      onClick={onClick}
      className={className}
      style={arrowStyle(style)}
      icon={<i className="fas fa-chevron-left arrow-slick" />}
    />
  );
};

const responsive = (dw, dl, tw, tl, mw, ml) => [
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: dw,
      slidesToScroll: dl,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: tw,
      slidesToScroll: tl,
    },
  },
  {
    breakpoint: 599,
    settings: {
      slidesToShow: mw,
      slidesToScroll: ml,
      centerMode: false,
      arrows: false,
      dots: true,
      centerPadding: "0",
    },
  },
  {
    breakpoint: 425,
    settings: {
      slidesToShow: mw,
      slidesToScroll: ml,
      centerMode: false,
      arrows: false,
      dots: true,
      centerPadding: "0",
    },
  },
  {
    breakpoint: 320,
    settings: {
      slidesToShow: mw,
      slidesToScroll: ml,
      centerMode: false,
      arrows: false,
      dots: true,
      centerPadding: "0",
    },
  },
];

export const bannerSettings = {
  dots: false,
  infinite: true,
  draggable: true,
  autoplay: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  centerMode: true,
  centerPadding: "20%",
  responsive: responsive(1, 1, 1, 1, 1, 1),
};

export const otherProductSettings = {
  dots: false,
  infinite: true,
  draggable: true,
  speed: 500,
  slidesToShow: 6,
  slidesToScroll: 2,
  initialSlide: 0,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 720,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
